import { BrowserRouter as Router } from "react-router-dom";
import { GlobalProvider } from "./includes";
import Routing from "./router";
import './app.less';

const App = () => {
    return <Router>
        <Routing />
    </Router>;
}

export default GlobalProvider(App);